import type {
  Assignment,
  AssignmentActivity,
  Book,
  ReadingLog,
} from '@monorepo/shared/src/graph/schema-generated-types-student';
import FeelingsMatchImage from 'assets/images/Feelings_match_badge.png';
import FindItLettersImage from 'assets/images/Find_it_letters_badge.png';
import FindItPicturesImage from 'assets/images/Find_it_pictures_badge.png';
import GuessTheOrderImage from 'assets/images/Guess_the_order_badge.png';
import GuessWhereImage from 'assets/images/Guess_where_badge.png';
import GuessWhoImage from 'assets/images/Guess_who_badge.png';
import MatchItTrashItImage from 'assets/images/Match_It_trash_It_badge.png';
import StartingSoundImage from 'assets/images/Starting_sounds_badge.png';
import WDTImage from 'assets/images/WDT.png';
import workbookImage from 'assets/images/workbook.png';
import fetchBookCoversHtml from 'util/fetch-book-covers-html';
import { ASSIGNMENT_STATUSES } from './types';

export const activitiesBadgeDict = {
  'feelings-match': FeelingsMatchImage,
  'find-the-letter': FindItLettersImage,
  'find-the-objects': FindItPicturesImage,
  'guess-the-order': GuessTheOrderImage,
  'guess-where': GuessWhereImage,
  'match-it-trash-it': MatchItTrashItImage,
  'guess-who': GuessWhoImage,
  'starting-sound': StartingSoundImage,
  'wet-dry-try': WDTImage,
  'practice-book': workbookImage,
};

export const fetchAndSetAssignmentsCovers = async (books: Book[], assignments: Assignment[]) => {
  const formattedCovers = await fetchBookCoversHtml(books);

  return books.map((book, index) => {
    const assignment = assignments.find((assignment) =>
      book.characters?.map((character) => character.id).includes(assignment.characterId)
    );

    return assignment
      ? {
          ...assignment,
          ...{ cover: formattedCovers[index] },
        }
      : {
          ...{ cover: formattedCovers[index] },
        };
  });
};

export const isCompletedStatus = (status: string) => {
  return status === ASSIGNMENT_STATUSES.COMPLETE || status === ASSIGNMENT_STATUSES.SKIPPED;
};

export const getAssignmentActivityCompletionStatus = (activity?: AssignmentActivity) => {
  return activity?.attempts?.every((attempt) => isCompletedStatus(attempt.status))
    ? ASSIGNMENT_STATUSES.COMPLETE
    : ASSIGNMENT_STATUSES.INCOMPLETE;
};

export const getAssignmentLetterBookCompletionStatus = (readingLogs: ReadingLog[]) => {
  return readingLogs.some((readingLog) => readingLog.bookCompleted)
    ? ASSIGNMENT_STATUSES.COMPLETE
    : ASSIGNMENT_STATUSES.INCOMPLETE;
};

export const getFirstIncompleteAssignment = (assignments: any[]) => {
  return assignments.find(
    (a) =>
      a.status &&
      a.status !== ASSIGNMENT_STATUSES.COMPLETE &&
      a.status !== ASSIGNMENT_STATUSES.SKIPPED
  );
};
